import theme from "@/theme";

export const styles = {
  modalContainer: {
    position: "absolute" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "506px",
    height: "589px",
    bgcolor: "#FFFFFF",
    borderRadius: "24px",
    padding: "22px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  modalContent: {
    width: "462px",
    height: "545px",
    display: "flex",
    flexDirection: "column",
    gap: "38px",
  },

  modalHeader: {
    width: "462px",
    height: "24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  headerText: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "100%",
    letterSpacing: "2%",
  },

  closeBtn: {
    padding: 0,
    width: "24px",
    height: "24px",
    margin: "1px 0 0 0",
  },

  reactionsContent: {
    width: "462px",
    height: "483px",
    display: "flex",
    flexDirection: "column",
    gap: "27px",
  },

  reactionsHeader: {
    width: "462px",
    height: "36px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  selectWrapper: {
    width: "142px",
  },

  tabsWrapper: {
    width: "184px",
    height: "24px",
    display: "flex",
    gap: "16px",
    alignItems: "center",
  },

  tabActive: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.custom.mainBlue,
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    position: "relative",

    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "-6px",
      left: 0,
      width: "100%",
      height: "2px",
      backgroundColor: theme.palette.custom.mainBlue,
      borderRadius: "2px",
    },
  },

  tabInactive: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#52575D",
    borderRadius: "6px",
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
  },

  reactionsBody: {
    width: "462px",
    height: "420px",
    overflowY: "auto",
    paddingRight: "8px",
  },
  //
  reactionItem: {
    width: "462px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    paddingTop: "12px",
    paddingBottom: "12px",
    borderBottom: "1px solid #F4F5F6",
    cursor: "pointer",
  },

  reactionAvatar: {
    width: "46px",
    height: "46px",
    borderRadius: "50%",
    backgroundColor: "#E0E0E0",
  },

  reactionUserBlock: {
    display: "flex",
    flexDirection: "column",
    width: "291px",
    gap: "4px",
  },

  reactionUserRow: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  reactionUsername: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "22px",
    letterSpacing: "-1%",
    color: "#383C40",
  },

  reactionTime: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "24px",
    letterSpacing: "-1.5%",
    color: "#9A9FA5",
  },

  reactionComment: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "20px",
    letterSpacing: "-1.5%",
    color: "#1A1D1F",
    maxWidth: "238px",
    wordWrap: "break-word",
    overflowWrap: "break-word",
    whiteSpace: "normal",
  },

  reactionAmountBox: {
    width: "109px",
    height: "44px",
    borderRadius: "20px",
    paddingTop: "4px",
    paddingBottom: "4px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },

  reactionIcon: {
    width: "24px",
    height: "24px",
  },

  reactionAmountValueBlock: {
    display: "flex",
    flexDirection: "column",
    width: "81px",
    height: "36px",
    justifyContent: "center",
  },

  reactionAmount: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "18px",
    color: "#1A1D1F",
  },

  reactionAmountUsd: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "18px",
    color: "#383C40",
  },
};
